import { useCallback, useEffect, useState } from "react";
import Logger from "../../../services/Logger";
import AdminGridBoardService from "./AdminGridBoardService";

export const usePuzzleData = (gridId, refresh = 0) => {
    const [hwTpl, setHwTpl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchHwTpl = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);

            const result = await AdminGridBoardService.requestHwTpl(gridId);
            setHwTpl(result);
        } catch (err) {
            Logger.error("Error fetching puzzle:", err);
            setError("Failed to fetch puzzle data. Please try again.");
        } finally {
            setLoading(false);
        }
    }, [gridId]);

    const refetch = useCallback(async () => {
        if (gridId) {
            await fetchHwTpl();
        }
    }, [gridId, fetchHwTpl]);

    useEffect(() => {
        if (gridId) {
            fetchHwTpl();
        }
    }, [gridId, refresh, fetchHwTpl]);

    return { hwTpl, loading, error, refetch };
};
